import { ArrowBack, InsertDriveFile } from "@material-ui/icons";
import React from "react";
import { SubjectTitle } from "../SubjectTitle";
import "./style.css";
import { Link } from "react-router-dom";
import { Contributor } from "../Contributor";
import Typewriter from "react-simple-typewriter";
import "react-simple-typewriter/dist/index.css";
export default function Resource({ title, type, items }) {
  return (
    <div className="container">
      <div className="resource-item">
        <SubjectTitle title={title} />
        <p>
          <Link
            className="link text-blue fit-content flex hover-push ai-c mt-3"
            to="/first-sem/iit"
          >
            <ArrowBack />
            Go back
          </Link>
        </p>

        <div className="my-3 text-capitalize type">
          <h2 className="text-dark-green">
            <Typewriter
              loop={false}
              cursor
              cursorStyle="|"
              typeSpeed={60}
              deleteSpeed={30}
              delaySpeed={1000}
              words={[type]}
            />
          </h2>
        </div>
        <ul className="items mt-3">
          {items.map((item, index) => (
            <li className="my-1 card p-2" key={index + 1}>
              <Link
                className="flex hover-white ai-c text-blue link-title"
                to={item.link}
              >
                <InsertDriveFile /> <span className="ml-1">{item.title}</span>
              </Link>
              {item.contributor && (
                <>
                  <h4 className="fw-600 my-1 text-capitalize">Contributors:</h4>
                  <ul className="contributor-list">
                    <Contributor
                      name={item.contributor}
                      link={item.contributor_link}
                    />
                  </ul>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
